// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pst {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.pst-card {
  background: var(--bg-card, color-mix(in srgb, currentColor 6%, transparent));
  border: 1px solid var(--profile-badge-border, var(--border-color));
  border-radius: 18px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pst-h {
  margin: 0;
  font-size: 15px;
  font-weight: 750;
  letter-spacing: -0.2px;
  color: var(--text-color);
}

.pst--health .pst-health-banner {
  background: color-mix(in srgb, #0877bc 8%, transparent);
  border-color: color-mix(in srgb, #0877bc 22%, var(--border-color, transparent));
}

.pst-card__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.pst-link-btn {
  border: none;
  background: none;
  color: #0877bc;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  font-size: 0.85rem;
}

.pst-link-btn:focus-visible,
.pst-block__head:focus-visible,
.pst-rail-card .digiping-smart-rail__node:focus-visible {
  outline: 2px solid var(--brand-primary, #0877BC);
  outline-offset: 2px;
}

.pst-metrics {
  margin-top: 4px;
}

.pst-muted,
.pst-empty-copy,
.pst-axis {
  margin: 0;
  font-size: 13px;
  color: var(--text-secondary);
  font-weight: 500;
  font-style: normal;
}

.pst-rail-card .digiping-smart-rail__node {
  appearance: none;
  -webkit-appearance: none;
  width: 2.05rem;
  height: 2.05rem;
  border-radius: 50%;
  border: 1.5px solid var(--profile-badge-border, rgba(128,128,128,0.25));
  background: var(--profile-subtle-bg, rgba(128,128,128,0.08));
  color: var(--text-secondary, #888);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 13px;
  cursor: pointer;
  transition: transform 0.35s cubic-bezier(0.25, 1, 0.5, 1), box-shadow 0.35s cubic-bezier(0.25, 1, 0.5, 1);
}

.pst-rail-card .digiping-smart-rail__track {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.pst-rail-card .digiping-smart-rail__link {
  flex: 1 1;
  height: 2px;
  margin: 0 4px;
  background: var(--profile-badge-border);
  border-radius: 2px;
}

.pst-rail-card .digiping-smart-rail__node.is-complete {
  color: #fff;
  border-color: transparent;
}
.pst-rail-card .digiping-smart-rail__node--s.is-complete { background: linear-gradient(135deg, #22d3ee, #0891b2); }
.pst-rail-card .digiping-smart-rail__node--m.is-complete { background: linear-gradient(135deg, #34d399, #059669); }
.pst-rail-card .digiping-smart-rail__node--a.is-complete { background: linear-gradient(135deg, #fbbf24, #d97706); }
.pst-rail-card .digiping-smart-rail__node--r.is-complete { background: linear-gradient(135deg, #fb7185, #e11d48); }
.pst-rail-card .digiping-smart-rail__node--t.is-complete { background: linear-gradient(135deg, #a78bfa, #7c3aed); }

.pst-rail-card .digiping-smart-rail__node.is-partial {
  border-color: var(--brand-primary, #0877BC);
  color: var(--brand-primary, #0877BC);
}

.pst-rail-card .digiping-smart-rail__node.is-active {
  transform: scale(1.18);
  outline: 2px solid currentColor;
  outline-offset: 3px;
  z-index: 1;
}

.pst-rail-card .digiping-smart-rail__node--s.is-active {
  color: #0891b2;
  box-shadow: 0 0 0 4px color-mix(in srgb, #22d3ee 45%, transparent), 0 10px 24px color-mix(in srgb, #22d3ee 32%, transparent);
}
.pst-rail-card .digiping-smart-rail__node--m.is-active {
  color: #059669;
  box-shadow: 0 0 0 4px color-mix(in srgb, #34d399 45%, transparent), 0 10px 24px color-mix(in srgb, #34d399 32%, transparent);
}
.pst-rail-card .digiping-smart-rail__node--a.is-active {
  color: #d97706;
  box-shadow: 0 0 0 4px color-mix(in srgb, #fbbf24 45%, transparent), 0 10px 24px color-mix(in srgb, #fbbf24 32%, transparent);
}
.pst-rail-card .digiping-smart-rail__node--r.is-active {
  color: #e11d48;
  box-shadow: 0 0 0 4px color-mix(in srgb, #fb7185 45%, transparent), 0 10px 24px color-mix(in srgb, #fb7185 32%, transparent);
}
.pst-rail-card .digiping-smart-rail__node--t.is-active {
  color: #7c3aed;
  box-shadow: 0 0 0 4px color-mix(in srgb, #a78bfa 45%, transparent), 0 10px 24px color-mix(in srgb, #a78bfa 32%, transparent);
}

.pst-rail-card .digiping-smart-rail__caption {
  font-size: 13px;
  font-weight: 800;
  color: var(--text-color);
  margin-top: 8px;
  letter-spacing: 0.02em;
}

.pst-board {
  transition: background 0.35s cubic-bezier(0.25, 1, 0.5, 1), border-color 0.35s cubic-bezier(0.25, 1, 0.5, 1);
}

.pst-board--s {
  background: color-mix(in srgb, #22d3ee 9%, var(--bg-card, transparent));
  border-color: color-mix(in srgb, #22d3ee 32%, var(--profile-badge-border, transparent));
}
.pst-board--m {
  background: color-mix(in srgb, #34d399 9%, var(--bg-card, transparent));
  border-color: color-mix(in srgb, #34d399 32%, var(--profile-badge-border, transparent));
}
.pst-board--a {
  background: color-mix(in srgb, #fbbf24 10%, var(--bg-card, transparent));
  border-color: color-mix(in srgb, #fbbf24 34%, var(--profile-badge-border, transparent));
}
.pst-board--r {
  background: color-mix(in srgb, #fb7185 9%, var(--bg-card, transparent));
  border-color: color-mix(in srgb, #fb7185 32%, var(--profile-badge-border, transparent));
}
.pst-board--t {
  background: color-mix(in srgb, #a78bfa 10%, var(--bg-card, transparent));
  border-color: color-mix(in srgb, #a78bfa 34%, var(--profile-badge-border, transparent));
}

.pst-dim-hint {
  margin: 10px 0 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
  line-height: 1.4;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.pst-dim-hint__letter {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.6rem;
  height: 1.6rem;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 800;
  color: #fff;
}

.pst-dim-hint--s .pst-dim-hint__letter { background: #0891b2; }
.pst-dim-hint--m .pst-dim-hint__letter { background: #059669; }
.pst-dim-hint--a .pst-dim-hint__letter { background: #d97706; }
.pst-dim-hint--r .pst-dim-hint__letter { background: #e11d48; }
.pst-dim-hint--t .pst-dim-hint__letter { background: #7c3aed; }

.pst-dim-panel {
  display: flex;
  flex-direction: column;
  gap: 14px;
  animation: pstPanelIn 0.4s cubic-bezier(0.25, 1, 0.5, 1);
}

@keyframes pstPanelIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.pst-season {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 16px 18px;
  border-radius: 18px;
  background:
    linear-gradient(135deg, color-mix(in srgb, #22d3ee 16%, transparent), color-mix(in srgb, #a78bfa 14%, transparent)),
    var(--bg-card, color-mix(in srgb, currentColor 6%, transparent));
  border: 1px solid color-mix(in srgb, #22d3ee 28%, var(--profile-badge-border, transparent));
  box-shadow: 0 10px 24px -12px color-mix(in srgb, #0891b2 35%, transparent);
}

.pst-season__copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.pst-season__kicker,
.pst-quest__kicker {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--brand-primary, #0877bc);
}

.pst-season__title {
  font-size: 17px;
  letter-spacing: -0.03em;
  color: var(--text-color);
}

.pst-season__hint {
  font-size: 13px;
  color: var(--text-secondary);
}

.pst-season__count {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
}

.pst-season__num {
  font-size: 28px;
  font-weight: 800;
  letter-spacing: -0.05em;
  line-height: 1;
  color: var(--text-color);
}

.pst-season__unit,
.pst-season__date {
  font-size: 11px;
  font-weight: 650;
  color: var(--text-secondary);
}

.pst-season__presence {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 6px;
  font-size: 12px;
  font-weight: 650;
  color: var(--text-secondary);
}

.pst-season__bar {
  display: block;
  height: 6px;
  border-radius: 99px;
  background: color-mix(in srgb, currentColor 12%, transparent);
  overflow: hidden;
}

.pst-season__bar > span {
  display: block;
  height: 100%;
  background: var(--brand-primary, #0877bc);
}

.pst-block__head > span {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  min-width: 0;
}

.pst-block__mark {
  display: inline-flex;
  width: 52px;
  height: 52px;
  border-radius: 14px;
  flex-shrink: 0;
  padding: 3px;
  box-sizing: border-box;
  vertical-align: middle;
  margin-right: 8px;
  background: color-mix(
    in srgb,
    var(--brand-primary-light, var(--brand-primary, #0877bc)) 18%,
    #ffffff
  );
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);
}

.pst-block__mark img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.dark-mode .pst-block__mark,
html[data-theme="dark"] .pst-block__mark {
  background: color-mix(
    in srgb,
    var(--brand-primary-light, var(--brand-primary, #0877bc)) 22%,
    #1f2937
  );
  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 32%, transparent);
}

.pst-quest-board {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.pst-quest-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.pst-quest {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
  border-radius: 18px;
  background: var(--bg-card, color-mix(in srgb, currentColor 6%, transparent));
  border: 1px solid var(--profile-badge-border, var(--border-color));
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 10px 15px -3px rgba(0, 0, 0, 0.03);
}

.pst-quest.is-primary {
  border-color: color-mix(in srgb, #22d3ee 42%, transparent);
  box-shadow:
    0 0 0 1px color-mix(in srgb, #22d3ee 18%, transparent),
    0 12px 28px -14px color-mix(in srgb, #0891b2 45%, transparent);
  background:
    linear-gradient(180deg, color-mix(in srgb, #22d3ee 10%, transparent), transparent 42%),
    var(--bg-card, color-mix(in srgb, currentColor 6%, transparent));
}

.pst-quest.is-secondary {
  border-color: color-mix(in srgb, #fbbf24 32%, transparent);
}

.pst-quest__head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
}

.pst-quest__head > div {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.pst-quest__pct {
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.04em;
  color: var(--text-color);
}

.pst-quest__title {
  margin: 0;
  font-size: 20px;
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.2;
}

.pst-quest.is-secondary .pst-quest__title {
  font-size: 16px;
}

.pst-quest__axis {
  margin: 0;
  font-size: 13px;
  color: var(--text-secondary);
}

.pst-bar {
  height: 7px;
  border-radius: 999px;
  background: color-mix(in srgb, currentColor 10%, transparent);
  overflow: hidden;
}

.pst-bar > span {
  display: block;
  height: 100%;
  border-radius: inherit;
  transition: width 0.5s cubic-bezier(0.25, 1, 0.5, 1);
}

.pst-quest__target,
.pst-quest__drill,
.pst-pact__seal {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 12px;
  border-radius: 14px;
  background: var(--profile-subtle-bg, rgba(128,128,128,0.08));
}

.pst-quest__target-label,
.pst-quest__drill-title {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.35;
}

.pst-quest__target-meta,
.pst-quest__drill-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.pst-chip--horizon {
  background: color-mix(in srgb, #a78bfa 18%, transparent);
  color: color-mix(in srgb, #6d28d9 70%, var(--text-color));
}

.pst-chip {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 700;
  background: var(--profile-badge-bg);
  color: var(--text-secondary);
}

.pst-chip--now { background: color-mix(in srgb, var(--brand-primary, #0877BC) 18%, transparent); color: var(--brand-primary, #0877BC); }
.pst-chip--ai { background: rgba(167, 139, 250, 0.18); color: #7c3aed; }
.pst-chip--pri { background: rgba(50, 215, 75, 0.16); color: #1f9d3a; }
.pst-chip--sec { background: rgba(255, 159, 10, 0.16); color: #c2410c; }
.pst-chip--ok { background: rgba(50, 215, 75, 0.16); color: #1f9d3a; }
.pst-chip--warn { background: rgba(255, 69, 58, 0.14); color: #c2410c; }

.pst-block__head {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  background: var(--profile-subtle-bg);
  border: none;
  border-radius: 12px;
  padding: 10px 12px;
  color: var(--text-color);
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  text-align: left;
}

.pst-block__head:hover,
.pst-block__head.is-open {
  background: var(--profile-hover-bg);
}

.pst-block {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.pst-block__aside {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.pst-block__count {
  min-width: 22px;
  height: 22px;
  border-radius: 11px;
  background: var(--profile-badge-bg);
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.pst-ex {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 4px 8px 8px;
  border-bottom: 1px solid var(--profile-badge-border);
}

.pst-ex:last-child { border-bottom: none; }

.pst-ex__name { font-weight: 650; font-size: 14px; }
.pst-ex__meta { display: flex; flex-wrap: wrap; gap: 4px; margin-top: 4px; }
.pst-ex__count { font-size: 12px; color: var(--text-secondary); white-space: nowrap; }

.pst-split {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.pst-eval-list,
.pst-metric-list,
.pst-todo,
.pst-miles {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pst-eval-list li,
.pst-metric-list li {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 13px;
}

.pst-metric-list li {
  flex-direction: row;
  justify-content: space-between;
}

.pst-eval__scores,
.pst-eval__date,
.pst-todo__detail,
.pst-miles__when {
  color: var(--text-secondary);
  font-size: 12px;
}

.pst-score {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.pst-score__num {
  font-size: 28px;
  font-weight: 800;
  letter-spacing: -0.04em;
}

.pst-presence {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  align-items: start;
}

.pst-presence__stat {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.pst-presence__stat strong {
  font-size: 20px;
  font-weight: 800;
}

.pst-presence__stat span {
  font-size: 11px;
  color: var(--text-secondary);
}

.pst-todo li,
.pst-miles li {
  padding: 10px 12px;
  border-radius: 12px;
  background: var(--profile-subtle-bg);
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.pst-todo li.is-high {
  border-left: 3px solid var(--brand-warning, #FF9F0A);
}

.pst-todo li.is-done {
  opacity: 0.72;
}

.pst-todo__title,
.pst-miles__label {
  font-weight: 700;
  font-size: 14px;
}

.pst-miles__top {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: flex-start;
}

.pst-empty {
  color: var(--text-secondary);
}

.pst-tech-progress {
  margin: 0;
  font-size: 13px;
  font-weight: 650;
  color: var(--text-secondary);
}

.pst-tech-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pst-tech-item {
  padding: 10px 12px;
  border-radius: 12px;
  background: var(--profile-subtle-bg, rgba(128, 128, 128, 0.08));
  border: 1px solid var(--profile-badge-border, rgba(128, 128, 128, 0.15));
}

.pst-tech-item__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
}

.pst-tech-item__block {
  font-size: 12px;
  font-weight: 750;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-secondary);
}

.pst-tech-item__answer {
  margin: 0;
  font-size: 14px;
  font-weight: 650;
  line-height: 1.45;
}

.pst-tech-item__question {
  margin: 6px 0 0;
  font-size: 12px;
  color: var(--text-secondary);
  line-height: 1.4;
}

.pst-timeline {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.pst-timeline li {
  display: grid;
  grid-template-columns: 16px 1fr;
  gap: 12px;
  padding: 10px 0;
  position: relative;
}

.pst-timeline li:not(:last-child)::before {
  content: "";
  position: absolute;
  left: 7px;
  top: 26px;
  bottom: -2px;
  width: 2px;
  background: var(--profile-badge-border);
}

.pst-timeline li > div {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.pst-timeline li span:last-child {
  font-size: 12px;
  color: var(--text-secondary);
}

.pst-timeline__dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin-top: 2px;
  background: var(--profile-badge-bg);
  box-shadow: 0 0 0 3px color-mix(in srgb, currentColor 8%, transparent);
}

.pst-timeline__dot.is-now { background: linear-gradient(135deg, #22d3ee, #0891b2); }
.pst-timeline__dot.is-mid { background: linear-gradient(135deg, #fbbf24, #d97706); }
.pst-timeline__dot.is-season { background: linear-gradient(135deg, #a78bfa, #7c3aed); }

@media (max-width: 560px) {
  .pst-split,
  .pst-presence,
  .pst-quest-grid {
    grid-template-columns: 1fr;
  }

  .pst-season {
    flex-direction: column;
    align-items: flex-start;
  }

  .pst-season__count {
    align-items: flex-start;
    flex-direction: row;
    gap: 8px;
    align-items: baseline;
  }

  .pst-season__num {
    font-size: 22px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .pst-dim-panel,
  .pst-rail-card .digiping-smart-rail__node,
  .pst-bar > span,
  .pst-board {
    animation: none;
    transition: none;
  }

  .pst-rail-card .digiping-smart-rail__node.is-active {
    transform: none;
  }
}

/* —— Competition season quest board —— */
.pst-sq-board {
  background: linear-gradient(145deg, color-mix(in srgb, #0877bc 8%, var(--bg-card, #fff)), var(--bg-card, #fff));
  border: 1px solid color-mix(in srgb, #0877bc 22%, var(--border-color));
  border-radius: 20px;
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.pst-sq-board__title {
  margin: 4px 0 0;
  font-size: 1.25rem;
  font-weight: 800;
  letter-spacing: -0.3px;
  color: var(--text-color, #0f172a);
}

.pst-sq-board__title--empty {
  font-size: 1.05rem;
  font-weight: 650;
  color: var(--text-secondary, #64748b);
}

.pst-sq-board__header .pst-season__kicker {
  color: #0369a1;
}

html[data-theme="dark"] .pst-sq-board__title,
body.dark-mode .pst-sq-board__title {
  color: #f8fafc;
}

html[data-theme="dark"] .pst-sq-board__header .pst-season__kicker,
body.dark-mode .pst-sq-board__header .pst-season__kicker {
  color: #7dd3fc;
}

.pst-sq-result-map {
  background: color-mix(in srgb, #0877bc 6%, transparent);
  border: 1px solid color-mix(in srgb, #0877bc 22%, var(--border-color));
  border-radius: 14px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pst-sq-result-map__result {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.4;
}

.pst-sq-result-map__result strong {
  font-size: 0.68rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-secondary, #64748b);
}

.pst-sq-axes {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pst-sq-axes li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 0.9rem;
  line-height: 1.35;
}

.pst-sq-axes--compact {
  gap: 6px;
}

.pst-sq-dim__kicker {
  margin: 0 0 6px;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-secondary, #64748b);
}

.pst-sq-phase {
  background: color-mix(in srgb, #0877bc 6%, transparent);
  border: 1px dashed color-mix(in srgb, #0877bc 28%, var(--border-color));
  border-radius: 14px;
  padding: 10px 12px;
}

.pst-sq-phase__lead {
  margin: 6px 0 0;
  font-size: 0.95rem;
  line-height: 1.45;
}

.pst-sq-cta {
  margin-top: 12px;
  border: 0;
  border-radius: 999px;
  padding: 8px 12px;
  font-weight: 700;
  font-size: 12px;
  background: #0877bc;
  color: #fff;
  cursor: pointer;
}

.pst-sq-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 10px;
}

.pst-sq-grid--smart {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

@media (max-width: 900px) {
  .pst-sq-grid--smart {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 520px) {
  .pst-sq-grid--smart {
    grid-template-columns: 1fr;
  }
}

.pst-collapse__head {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
  font: inherit;
}

.pst-collapse__title {
  display: block;
  margin: 0;
  font-size: 1rem;
}

.pst-collapse__hint {
  display: block;
  margin-top: 4px;
  font-style: normal;
  font-size: 0.78rem;
  color: var(--text-secondary, #64748b);
  line-height: 1.35;
}

.pst-collapse__chevron {
  flex-shrink: 0;
  font-size: 0.9rem;
  color: var(--text-secondary, #64748b);
  padding-top: 2px;
}

.pst-collapse__body {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pst-sq-metrics {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

@media (max-width: 560px) {
  .pst-sq-metrics {
    grid-template-columns: 1fr;
  }
}

.pst-sq-dim {
  background: color-mix(in srgb, currentColor 4%, transparent);
  border: 1px solid var(--profile-badge-border, rgba(128, 128, 128, 0.2));
  border-radius: 14px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pst-sq-dim__head {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pst-sq-dim__letter {
  width: 1.65rem;
  height: 1.65rem;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 12px;
  background: color-mix(in srgb, #0877bc 18%, transparent);
  color: #0877bc;
}

.pst-sq-dim--a .pst-sq-dim__letter { background: color-mix(in srgb, #d97706 18%, transparent); color: #b45309; }
.pst-sq-dim--r .pst-sq-dim__letter { background: color-mix(in srgb, #7c3aed 18%, transparent); color: #6d28d9; }
.pst-sq-dim--m .pst-sq-dim__letter { background: color-mix(in srgb, #059669 18%, transparent); color: #047857; }
.pst-sq-dim--t .pst-sq-dim__letter { background: color-mix(in srgb, #0891b2 18%, transparent); color: #0e7490; }

.pst-sq-dim__title {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-secondary);
  flex: 1 1;
}

.pst-sq-dim__lead {
  margin: 0;
  font-size: 14px;
  font-weight: 650;
  line-height: 1.35;
}

.pst-sq-metric-line {
  margin: 0;
  font-size: 13px;
}

.pst-sq-time-bar {
  margin-top: 6px;
}

.pst-traffic {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.pst-traffic--green { background: #22c55e; }
.pst-traffic--yellow { background: #eab308; }
.pst-traffic--red { background: #ef4444; }

/* Coach SMART review grid */
.dp-smart-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 12px;
}

.dp-smart-grid__cell {
  border: 1px solid var(--border-color, rgba(128, 128, 128, 0.25));
  border-radius: 12px;
  padding: 10px 6px;
  font-size: 12px;
  background: var(--bg-card, rgba(128, 128, 128, 0.06));
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-height: 3.1rem;
  cursor: pointer;
  color: inherit;
  font-family: inherit;
}

.dp-smart-grid__cell.is-active {
  border-color: #0877bc;
  box-shadow: 0 0 0 1px color-mix(in srgb, #0877bc 30%, transparent);
}

.dp-smart-grid__letter {
  font-weight: 800;
  font-size: 14px;
}

.dp-smart-grid__status {
  display: block;
  margin-top: 4px;
  color: var(--text-secondary);
  font-size: 11px;
}

/* Sprint exercise M table */
.pst-sprint-table-wrap {
  margin-top: 12px;
}

.pst-sprint-table__head {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

.pst-sprint-table__badges {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: flex-start;
}

.pst-sprint-table-scroll {
  overflow-x: auto;
  border-radius: 12px;
  border: 1px solid var(--profile-badge-border, rgba(128, 128, 128, 0.2));
}

.pst-sprint-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.pst-sprint-table th,
.pst-sprint-table td {
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid var(--profile-badge-border, rgba(128, 128, 128, 0.15));
  vertical-align: top;
}

.pst-sprint-table th {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-secondary);
  background: color-mix(in srgb, currentColor 4%, transparent);
}

.pst-sprint-row.is-ok {
  background: color-mix(in srgb, #22c55e 6%, transparent);
}

.pst-sprint-row.is-warn {
  background: color-mix(in srgb, #ef4444 5%, transparent);
}

.pst-sprint-row__goal {
  min-width: 140px;
}

.pst-sprint-row__role {
  margin-right: 6px;
  opacity: 0.7;
}

.pst-sprint-row__sub {
  display: block;
  font-size: 12px;
}

.pst-sprint-metrics {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.pst-sprint-metrics__label {
  display: block;
  font-size: 11px;
  color: var(--text-secondary);
}

.pst-sprint-ok {
  color: #059669;
  font-weight: 650;
}

.pst-sprint-warn {
  color: #d97706;
  font-weight: 650;
}

.pst-sprint-cb-groups {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pst-sprint-cb-group summary {
  cursor: pointer;
  font-weight: 650;
  font-size: 13px;
}

.pst-sprint-cb-list {
  margin: 8px 0 0 18px;
  padding: 0;
  font-size: 13px;
}

.pst-sprint-card,
.pst-measure-plan {
  margin-bottom: 0;
}

.dp-people__sprint-review {
  margin-bottom: 12px;
}

.pst-m,
.pst-t {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.pst-meter-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}

@media (min-width: 560px) {
  .pst-meter-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.pst-meter {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 14px 14px 12px;
  border-radius: 16px;
  background: var(--bg-card, #fff);
  border: 1px solid var(--profile-badge-border, rgba(128, 128, 128, 0.16));
}

.pst-meter__kicker {
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--text-secondary, #64748b);
}

.pst-meter__value {
  font-size: 1.55rem;
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.1;
  color: var(--text-color, #0f172a);
}

.pst-meter__unit {
  font-size: 0.78rem;
  color: var(--text-secondary, #64748b);
  line-height: 1.3;
}

.pst-meter__pace {
  font-size: 0.72rem;
  font-weight: 650;
  color: var(--brand-primary, #0877bc);
  margin-top: 2px;
}

.pst-meter .pst-bar {
  margin-top: 8px;
}

.pst-ae-card__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
}

.pst-ae-spark {
  display: flex;
  align-items: flex-end;
  gap: 6px;
  height: 56px;
  margin: 10px 0 14px;
  padding: 0 2px;
}

.pst-ae-spark__bar {
  flex: 1 1;
  min-width: 8px;
  border-radius: 6px 6px 2px 2px;
  background: linear-gradient(180deg, #34d399, #059669);
  opacity: 0.9;
}

.pst-ae-last {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-top: 10px;
  border-top: 1px solid var(--profile-badge-border, rgba(128, 128, 128, 0.14));
}

.pst-ae-last__row {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.pst-ae-last__row strong {
  font-size: 0.95rem;
}

.pst-ae-last__row span,
.pst-ae-last__row em {
  font-size: 0.8rem;
  color: var(--text-secondary, #64748b);
  font-style: normal;
}

.pst-miles__presence {
  background: color-mix(in srgb, #fbbf24 10%, transparent);
  border-radius: 12px;
  padding: 10px 12px;
  margin-bottom: 6px;
}

.pst-track {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pst-track__head {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.pst-track__head .pst-h {
  margin: 0;
}

.pst-track__goal {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.35;
}

.pst-track__stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.pst-track__stats > div {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px;
  border-radius: 12px;
  background: color-mix(in srgb, currentColor 5%, transparent);
}

.pst-track__stats strong {
  font-size: 1.15rem;
  font-weight: 800;
  letter-spacing: -0.02em;
}

.pst-track__stats span {
  font-size: 0.68rem;
  line-height: 1.25;
  color: var(--text-secondary, #64748b);
}

.pst-track__bar {
  position: relative;
  height: 10px;
  border-radius: 999px;
  background: color-mix(in srgb, currentColor 10%, transparent);
  overflow: visible;
}

.pst-track__fill {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #a78bfa, #7c3aed);
}

.pst-track__fill--cycle {
  background: linear-gradient(90deg, #22d3ee, #0891b2);
}

.pst-track__now {
  position: absolute;
  top: 50%;
  width: 14px;
  height: 14px;
  margin-left: -7px;
  margin-top: -7px;
  border-radius: 50%;
  background: var(--brand-primary, #0877bc);
  border: 2px solid #fff;
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--brand-primary, #0877bc) 35%, transparent);
}

.pst-track__ticks {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
}

.pst-track__ticks li {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px;
  border-radius: 10px;
  opacity: 0.65;
}

.pst-track__ticks li.is-current {
  opacity: 1;
  background: color-mix(in srgb, #22d3ee 12%, transparent);
}

.pst-track__ticks strong {
  font-size: 0.78rem;
}

.pst-track__ticks span {
  font-size: 0.7rem;
  color: var(--text-secondary, #64748b);
}

.pst-track--season {
  border-color: color-mix(in srgb, #a78bfa 28%, var(--profile-badge-border, transparent));
}

.pst-track--cycle {
  border-color: color-mix(in srgb, #22d3ee 28%, var(--profile-badge-border, transparent));
}
`, "",{"version":3,"sources":["webpack://./src/components/ProfileSmartTab.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,4EAA4E;EAC5E,kEAAkE;EAClE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,uDAAuD;EACvD,+EAA+E;AACjF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,kBAAkB;AACpB;;AAEA;;;EAGE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,SAAS;EACT,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,uEAAuE;EACvE,4DAA4D;EAC5D,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yGAAyG;AAC3G;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,WAAW;EACX,aAAa;EACb,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA,2DAA2D,qDAAqD,EAAE;AAClH,2DAA2D,qDAAqD,EAAE;AAClH,2DAA2D,qDAAqD,EAAE;AAClH,2DAA2D,qDAAqD,EAAE;AAClH,2DAA2D,qDAAqD,EAAE;;AAElH;EACE,2CAA2C;EAC3C,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,4HAA4H;AAC9H;AACA;EACE,cAAc;EACd,4HAA4H;AAC9H;AACA;EACE,cAAc;EACd,4HAA4H;AAC9H;AACA;EACE,cAAc;EACd,4HAA4H;AAC9H;AACA;EACE,cAAc;EACd,4HAA4H;AAC9H;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,4GAA4G;AAC9G;;AAEA;EACE,uEAAuE;EACvE,uFAAuF;AACzF;AACA;EACE,uEAAuE;EACvE,uFAAuF;AACzF;AACA;EACE,wEAAwE;EACxE,uFAAuF;AACzF;AACA;EACE,uEAAuE;EACvE,uFAAuF;AACzF;AACA;EACE,wEAAwE;EACxE,uFAAuF;AACzF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA,yCAAyC,mBAAmB,EAAE;AAC9D,yCAAyC,mBAAmB,EAAE;AAC9D,yCAAyC,mBAAmB,EAAE;AAC9D,yCAAyC,mBAAmB,EAAE;AAC9D,yCAAyC,mBAAmB,EAAE;;AAE9D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,wDAAwD;AAC1D;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB;;oEAEkE;EAClE,2FAA2F;EAC3F,0EAA0E;AAC5E;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,6DAA6D;EAC7D,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB;;;;GAIC;EACD,oFAAoF;AACtF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE;;;;GAIC;EACD,gFAAgF;AAClF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,4EAA4E;EAC5E,kEAAkE;EAClE,oFAAoF;AACtF;;AAEA;EACE,0DAA0D;EAC1D;;kEAEgE;EAChE;;oEAEkE;AACpE;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,6DAA6D;EAC7D,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,oDAAoD;AACtD;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,4DAA4D;AAC9D;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,wDAAwD;EACxD,yDAAyD;AAC3D;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA,iBAAiB,8EAA8E,EAAE,oCAAoC,EAAE;AACvI,gBAAgB,qCAAqC,EAAE,cAAc,EAAE;AACvE,iBAAiB,mCAAmC,EAAE,cAAc,EAAE;AACtE,iBAAiB,oCAAoC,EAAE,cAAc,EAAE;AACvE,gBAAgB,mCAAmC,EAAE,cAAc,EAAE;AACrE,kBAAkB,mCAAmC,EAAE,cAAc,EAAE;;AAEvE;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,wBAAwB;EACxB,oDAAoD;AACtD;;AAEA,qBAAqB,mBAAmB,EAAE;;AAE1C,gBAAgB,gBAAgB,EAAE,eAAe,EAAE;AACnD,gBAAgB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,eAAe,EAAE;AAC3E,iBAAiB,eAAe,EAAE,4BAA4B,EAAE,mBAAmB,EAAE;;AAErF;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;;;EAIE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;;;EAIE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,+DAA+D;EAC/D,wEAAwE;AAC1E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,YAAY;EACZ,UAAU;EACV,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mCAAmC;EACnC,sEAAsE;AACxE;;AAEA,4BAA4B,qDAAqD,EAAE;AACnF,4BAA4B,qDAAqD,EAAE;AACnF,+BAA+B,qDAAqD,EAAE;;AAEtF;EACE;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;;;IAIE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,yCAAyC;AACzC;EACE,+GAA+G;EAC/G,sEAAsE;EACtE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,uDAAuD;EACvD,sEAAsE;EACtE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,uDAAuD;EACvD,uEAAuE;EACvE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,4DAA4D;EAC5D,uEAAuE;EACvE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,wDAAwD;EACxD,cAAc;AAChB;;AAEA,qCAAqC,wDAAwD,EAAE,cAAc,EAAE;AAC/G,qCAAqC,wDAAwD,EAAE,cAAc,EAAE;AAC/G,qCAAqC,wDAAwD,EAAE,cAAc,EAAE;AAC/G,qCAAqC,wDAAwD,EAAE,cAAc,EAAE;;AAE/G;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,SAAO;AACT;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA,sBAAsB,mBAAmB,EAAE;AAC3C,uBAAuB,mBAAmB,EAAE;AAC5C,oBAAoB,mBAAmB,EAAE;;AAEzC,4BAA4B;AAC5B;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gEAAgE;EAChE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,qDAAqD;EACrD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,kEAAkE;AACpE;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uEAAuE;AACzE;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,+EAA+E;EAC/E,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,4DAA4D;AAC9D;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,wEAAwE;AAC1E;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,8BAA8B;EAC9B,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,4EAA4E;AAC9E;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,wDAAwD;EACxD,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,6DAA6D;EAC7D,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,sBAAsB;EACtB,wFAAwF;AAC1F;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,uFAAuF;AACzF;;AAEA;EACE,uFAAuF;AACzF","sourcesContent":[".pst {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.pst-card {\n  background: var(--bg-card, color-mix(in srgb, currentColor 6%, transparent));\n  border: 1px solid var(--profile-badge-border, var(--border-color));\n  border-radius: 18px;\n  padding: 14px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.pst-h {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 750;\n  letter-spacing: -0.2px;\n  color: var(--text-color);\n}\n\n.pst--health .pst-health-banner {\n  background: color-mix(in srgb, #0877bc 8%, transparent);\n  border-color: color-mix(in srgb, #0877bc 22%, var(--border-color, transparent));\n}\n\n.pst-card__actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.pst-link-btn {\n  border: none;\n  background: none;\n  color: #0877bc;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n  font-size: 0.85rem;\n}\n\n.pst-link-btn:focus-visible,\n.pst-block__head:focus-visible,\n.pst-rail-card .digiping-smart-rail__node:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877BC);\n  outline-offset: 2px;\n}\n\n.pst-metrics {\n  margin-top: 4px;\n}\n\n.pst-muted,\n.pst-empty-copy,\n.pst-axis {\n  margin: 0;\n  font-size: 13px;\n  color: var(--text-secondary);\n  font-weight: 500;\n  font-style: normal;\n}\n\n.pst-rail-card .digiping-smart-rail__node {\n  appearance: none;\n  -webkit-appearance: none;\n  width: 2.05rem;\n  height: 2.05rem;\n  border-radius: 50%;\n  border: 1.5px solid var(--profile-badge-border, rgba(128,128,128,0.25));\n  background: var(--profile-subtle-bg, rgba(128,128,128,0.08));\n  color: var(--text-secondary, #888);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 800;\n  font-size: 13px;\n  cursor: pointer;\n  transition: transform 0.35s cubic-bezier(0.25, 1, 0.5, 1), box-shadow 0.35s cubic-bezier(0.25, 1, 0.5, 1);\n}\n\n.pst-rail-card .digiping-smart-rail__track {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.pst-rail-card .digiping-smart-rail__link {\n  flex: 1;\n  height: 2px;\n  margin: 0 4px;\n  background: var(--profile-badge-border);\n  border-radius: 2px;\n}\n\n.pst-rail-card .digiping-smart-rail__node.is-complete {\n  color: #fff;\n  border-color: transparent;\n}\n.pst-rail-card .digiping-smart-rail__node--s.is-complete { background: linear-gradient(135deg, #22d3ee, #0891b2); }\n.pst-rail-card .digiping-smart-rail__node--m.is-complete { background: linear-gradient(135deg, #34d399, #059669); }\n.pst-rail-card .digiping-smart-rail__node--a.is-complete { background: linear-gradient(135deg, #fbbf24, #d97706); }\n.pst-rail-card .digiping-smart-rail__node--r.is-complete { background: linear-gradient(135deg, #fb7185, #e11d48); }\n.pst-rail-card .digiping-smart-rail__node--t.is-complete { background: linear-gradient(135deg, #a78bfa, #7c3aed); }\n\n.pst-rail-card .digiping-smart-rail__node.is-partial {\n  border-color: var(--brand-primary, #0877BC);\n  color: var(--brand-primary, #0877BC);\n}\n\n.pst-rail-card .digiping-smart-rail__node.is-active {\n  transform: scale(1.18);\n  outline: 2px solid currentColor;\n  outline-offset: 3px;\n  z-index: 1;\n}\n\n.pst-rail-card .digiping-smart-rail__node--s.is-active {\n  color: #0891b2;\n  box-shadow: 0 0 0 4px color-mix(in srgb, #22d3ee 45%, transparent), 0 10px 24px color-mix(in srgb, #22d3ee 32%, transparent);\n}\n.pst-rail-card .digiping-smart-rail__node--m.is-active {\n  color: #059669;\n  box-shadow: 0 0 0 4px color-mix(in srgb, #34d399 45%, transparent), 0 10px 24px color-mix(in srgb, #34d399 32%, transparent);\n}\n.pst-rail-card .digiping-smart-rail__node--a.is-active {\n  color: #d97706;\n  box-shadow: 0 0 0 4px color-mix(in srgb, #fbbf24 45%, transparent), 0 10px 24px color-mix(in srgb, #fbbf24 32%, transparent);\n}\n.pst-rail-card .digiping-smart-rail__node--r.is-active {\n  color: #e11d48;\n  box-shadow: 0 0 0 4px color-mix(in srgb, #fb7185 45%, transparent), 0 10px 24px color-mix(in srgb, #fb7185 32%, transparent);\n}\n.pst-rail-card .digiping-smart-rail__node--t.is-active {\n  color: #7c3aed;\n  box-shadow: 0 0 0 4px color-mix(in srgb, #a78bfa 45%, transparent), 0 10px 24px color-mix(in srgb, #a78bfa 32%, transparent);\n}\n\n.pst-rail-card .digiping-smart-rail__caption {\n  font-size: 13px;\n  font-weight: 800;\n  color: var(--text-color);\n  margin-top: 8px;\n  letter-spacing: 0.02em;\n}\n\n.pst-board {\n  transition: background 0.35s cubic-bezier(0.25, 1, 0.5, 1), border-color 0.35s cubic-bezier(0.25, 1, 0.5, 1);\n}\n\n.pst-board--s {\n  background: color-mix(in srgb, #22d3ee 9%, var(--bg-card, transparent));\n  border-color: color-mix(in srgb, #22d3ee 32%, var(--profile-badge-border, transparent));\n}\n.pst-board--m {\n  background: color-mix(in srgb, #34d399 9%, var(--bg-card, transparent));\n  border-color: color-mix(in srgb, #34d399 32%, var(--profile-badge-border, transparent));\n}\n.pst-board--a {\n  background: color-mix(in srgb, #fbbf24 10%, var(--bg-card, transparent));\n  border-color: color-mix(in srgb, #fbbf24 34%, var(--profile-badge-border, transparent));\n}\n.pst-board--r {\n  background: color-mix(in srgb, #fb7185 9%, var(--bg-card, transparent));\n  border-color: color-mix(in srgb, #fb7185 32%, var(--profile-badge-border, transparent));\n}\n.pst-board--t {\n  background: color-mix(in srgb, #a78bfa 10%, var(--bg-card, transparent));\n  border-color: color-mix(in srgb, #a78bfa 34%, var(--profile-badge-border, transparent));\n}\n\n.pst-dim-hint {\n  margin: 10px 0 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  line-height: 1.4;\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.pst-dim-hint__letter {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.6rem;\n  height: 1.6rem;\n  border-radius: 8px;\n  font-size: 0.85rem;\n  font-weight: 800;\n  color: #fff;\n}\n\n.pst-dim-hint--s .pst-dim-hint__letter { background: #0891b2; }\n.pst-dim-hint--m .pst-dim-hint__letter { background: #059669; }\n.pst-dim-hint--a .pst-dim-hint__letter { background: #d97706; }\n.pst-dim-hint--r .pst-dim-hint__letter { background: #e11d48; }\n.pst-dim-hint--t .pst-dim-hint__letter { background: #7c3aed; }\n\n.pst-dim-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  animation: pstPanelIn 0.4s cubic-bezier(0.25, 1, 0.5, 1);\n}\n\n@keyframes pstPanelIn {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.pst-season {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  padding: 16px 18px;\n  border-radius: 18px;\n  background:\n    linear-gradient(135deg, color-mix(in srgb, #22d3ee 16%, transparent), color-mix(in srgb, #a78bfa 14%, transparent)),\n    var(--bg-card, color-mix(in srgb, currentColor 6%, transparent));\n  border: 1px solid color-mix(in srgb, #22d3ee 28%, var(--profile-badge-border, transparent));\n  box-shadow: 0 10px 24px -12px color-mix(in srgb, #0891b2 35%, transparent);\n}\n\n.pst-season__copy {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.pst-season__kicker,\n.pst-quest__kicker {\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--brand-primary, #0877bc);\n}\n\n.pst-season__title {\n  font-size: 17px;\n  letter-spacing: -0.03em;\n  color: var(--text-color);\n}\n\n.pst-season__hint {\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n.pst-season__count {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  flex-shrink: 0;\n}\n\n.pst-season__num {\n  font-size: 28px;\n  font-weight: 800;\n  letter-spacing: -0.05em;\n  line-height: 1;\n  color: var(--text-color);\n}\n\n.pst-season__unit,\n.pst-season__date {\n  font-size: 11px;\n  font-weight: 650;\n  color: var(--text-secondary);\n}\n\n.pst-season__presence {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-top: 6px;\n  font-size: 12px;\n  font-weight: 650;\n  color: var(--text-secondary);\n}\n\n.pst-season__bar {\n  display: block;\n  height: 6px;\n  border-radius: 99px;\n  background: color-mix(in srgb, currentColor 12%, transparent);\n  overflow: hidden;\n}\n\n.pst-season__bar > span {\n  display: block;\n  height: 100%;\n  background: var(--brand-primary, #0877bc);\n}\n\n.pst-block__head > span {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  min-width: 0;\n}\n\n.pst-block__mark {\n  display: inline-flex;\n  width: 52px;\n  height: 52px;\n  border-radius: 14px;\n  flex-shrink: 0;\n  padding: 3px;\n  box-sizing: border-box;\n  vertical-align: middle;\n  margin-right: 8px;\n  background: color-mix(\n    in srgb,\n    var(--brand-primary-light, var(--brand-primary, #0877bc)) 18%,\n    #ffffff\n  );\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);\n}\n\n.pst-block__mark img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.dark-mode .pst-block__mark,\nhtml[data-theme=\"dark\"] .pst-block__mark {\n  background: color-mix(\n    in srgb,\n    var(--brand-primary-light, var(--brand-primary, #0877bc)) 22%,\n    #1f2937\n  );\n  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 32%, transparent);\n}\n\n.pst-quest-board {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.pst-quest-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.pst-quest {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 16px;\n  border-radius: 18px;\n  background: var(--bg-card, color-mix(in srgb, currentColor 6%, transparent));\n  border: 1px solid var(--profile-badge-border, var(--border-color));\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 10px 15px -3px rgba(0, 0, 0, 0.03);\n}\n\n.pst-quest.is-primary {\n  border-color: color-mix(in srgb, #22d3ee 42%, transparent);\n  box-shadow:\n    0 0 0 1px color-mix(in srgb, #22d3ee 18%, transparent),\n    0 12px 28px -14px color-mix(in srgb, #0891b2 45%, transparent);\n  background:\n    linear-gradient(180deg, color-mix(in srgb, #22d3ee 10%, transparent), transparent 42%),\n    var(--bg-card, color-mix(in srgb, currentColor 6%, transparent));\n}\n\n.pst-quest.is-secondary {\n  border-color: color-mix(in srgb, #fbbf24 32%, transparent);\n}\n\n.pst-quest__head {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.pst-quest__head > div {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.pst-quest__pct {\n  font-size: 18px;\n  font-weight: 800;\n  letter-spacing: -0.04em;\n  color: var(--text-color);\n}\n\n.pst-quest__title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  line-height: 1.2;\n}\n\n.pst-quest.is-secondary .pst-quest__title {\n  font-size: 16px;\n}\n\n.pst-quest__axis {\n  margin: 0;\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n.pst-bar {\n  height: 7px;\n  border-radius: 999px;\n  background: color-mix(in srgb, currentColor 10%, transparent);\n  overflow: hidden;\n}\n\n.pst-bar > span {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  transition: width 0.5s cubic-bezier(0.25, 1, 0.5, 1);\n}\n\n.pst-quest__target,\n.pst-quest__drill,\n.pst-pact__seal {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 10px 12px;\n  border-radius: 14px;\n  background: var(--profile-subtle-bg, rgba(128,128,128,0.08));\n}\n\n.pst-quest__target-label,\n.pst-quest__drill-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.35;\n}\n\n.pst-quest__target-meta,\n.pst-quest__drill-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.pst-chip--horizon {\n  background: color-mix(in srgb, #a78bfa 18%, transparent);\n  color: color-mix(in srgb, #6d28d9 70%, var(--text-color));\n}\n\n.pst-chip {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 999px;\n  padding: 2px 8px;\n  font-size: 11px;\n  font-weight: 700;\n  background: var(--profile-badge-bg);\n  color: var(--text-secondary);\n}\n\n.pst-chip--now { background: color-mix(in srgb, var(--brand-primary, #0877BC) 18%, transparent); color: var(--brand-primary, #0877BC); }\n.pst-chip--ai { background: rgba(167, 139, 250, 0.18); color: #7c3aed; }\n.pst-chip--pri { background: rgba(50, 215, 75, 0.16); color: #1f9d3a; }\n.pst-chip--sec { background: rgba(255, 159, 10, 0.16); color: #c2410c; }\n.pst-chip--ok { background: rgba(50, 215, 75, 0.16); color: #1f9d3a; }\n.pst-chip--warn { background: rgba(255, 69, 58, 0.14); color: #c2410c; }\n\n.pst-block__head {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n  background: var(--profile-subtle-bg);\n  border: none;\n  border-radius: 12px;\n  padding: 10px 12px;\n  color: var(--text-color);\n  font-weight: 700;\n  font-size: 14px;\n  cursor: pointer;\n  text-align: left;\n}\n\n.pst-block__head:hover,\n.pst-block__head.is-open {\n  background: var(--profile-hover-bg);\n}\n\n.pst-block {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.pst-block__aside {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.pst-block__count {\n  min-width: 22px;\n  height: 22px;\n  border-radius: 11px;\n  background: var(--profile-badge-bg);\n  font-size: 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pst-ex {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 8px 4px 8px 8px;\n  border-bottom: 1px solid var(--profile-badge-border);\n}\n\n.pst-ex:last-child { border-bottom: none; }\n\n.pst-ex__name { font-weight: 650; font-size: 14px; }\n.pst-ex__meta { display: flex; flex-wrap: wrap; gap: 4px; margin-top: 4px; }\n.pst-ex__count { font-size: 12px; color: var(--text-secondary); white-space: nowrap; }\n\n.pst-split {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.pst-eval-list,\n.pst-metric-list,\n.pst-todo,\n.pst-miles {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.pst-eval-list li,\n.pst-metric-list li {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  font-size: 13px;\n}\n\n.pst-metric-list li {\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.pst-eval__scores,\n.pst-eval__date,\n.pst-todo__detail,\n.pst-miles__when {\n  color: var(--text-secondary);\n  font-size: 12px;\n}\n\n.pst-score {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n\n.pst-score__num {\n  font-size: 28px;\n  font-weight: 800;\n  letter-spacing: -0.04em;\n}\n\n.pst-presence {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n  align-items: start;\n}\n\n.pst-presence__stat {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.pst-presence__stat strong {\n  font-size: 20px;\n  font-weight: 800;\n}\n\n.pst-presence__stat span {\n  font-size: 11px;\n  color: var(--text-secondary);\n}\n\n.pst-todo li,\n.pst-miles li {\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: var(--profile-subtle-bg);\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.pst-todo li.is-high {\n  border-left: 3px solid var(--brand-warning, #FF9F0A);\n}\n\n.pst-todo li.is-done {\n  opacity: 0.72;\n}\n\n.pst-todo__title,\n.pst-miles__label {\n  font-weight: 700;\n  font-size: 14px;\n}\n\n.pst-miles__top {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  align-items: flex-start;\n}\n\n.pst-empty {\n  color: var(--text-secondary);\n}\n\n.pst-tech-progress {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 650;\n  color: var(--text-secondary);\n}\n\n.pst-tech-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.pst-tech-item {\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: var(--profile-subtle-bg, rgba(128, 128, 128, 0.08));\n  border: 1px solid var(--profile-badge-border, rgba(128, 128, 128, 0.15));\n}\n\n.pst-tech-item__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 4px;\n}\n\n.pst-tech-item__block {\n  font-size: 12px;\n  font-weight: 750;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--text-secondary);\n}\n\n.pst-tech-item__answer {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 650;\n  line-height: 1.45;\n}\n\n.pst-tech-item__question {\n  margin: 6px 0 0;\n  font-size: 12px;\n  color: var(--text-secondary);\n  line-height: 1.4;\n}\n\n.pst-timeline {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.pst-timeline li {\n  display: grid;\n  grid-template-columns: 16px 1fr;\n  gap: 12px;\n  padding: 10px 0;\n  position: relative;\n}\n\n.pst-timeline li:not(:last-child)::before {\n  content: \"\";\n  position: absolute;\n  left: 7px;\n  top: 26px;\n  bottom: -2px;\n  width: 2px;\n  background: var(--profile-badge-border);\n}\n\n.pst-timeline li > div {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.pst-timeline li span:last-child {\n  font-size: 12px;\n  color: var(--text-secondary);\n}\n\n.pst-timeline__dot {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  margin-top: 2px;\n  background: var(--profile-badge-bg);\n  box-shadow: 0 0 0 3px color-mix(in srgb, currentColor 8%, transparent);\n}\n\n.pst-timeline__dot.is-now { background: linear-gradient(135deg, #22d3ee, #0891b2); }\n.pst-timeline__dot.is-mid { background: linear-gradient(135deg, #fbbf24, #d97706); }\n.pst-timeline__dot.is-season { background: linear-gradient(135deg, #a78bfa, #7c3aed); }\n\n@media (max-width: 560px) {\n  .pst-split,\n  .pst-presence,\n  .pst-quest-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .pst-season {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .pst-season__count {\n    align-items: flex-start;\n    flex-direction: row;\n    gap: 8px;\n    align-items: baseline;\n  }\n\n  .pst-season__num {\n    font-size: 22px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .pst-dim-panel,\n  .pst-rail-card .digiping-smart-rail__node,\n  .pst-bar > span,\n  .pst-board {\n    animation: none;\n    transition: none;\n  }\n\n  .pst-rail-card .digiping-smart-rail__node.is-active {\n    transform: none;\n  }\n}\n\n/* —— Competition season quest board —— */\n.pst-sq-board {\n  background: linear-gradient(145deg, color-mix(in srgb, #0877bc 8%, var(--bg-card, #fff)), var(--bg-card, #fff));\n  border: 1px solid color-mix(in srgb, #0877bc 22%, var(--border-color));\n  border-radius: 20px;\n  padding: 16px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.pst-sq-board__title {\n  margin: 4px 0 0;\n  font-size: 1.25rem;\n  font-weight: 800;\n  letter-spacing: -0.3px;\n  color: var(--text-color, #0f172a);\n}\n\n.pst-sq-board__title--empty {\n  font-size: 1.05rem;\n  font-weight: 650;\n  color: var(--text-secondary, #64748b);\n}\n\n.pst-sq-board__header .pst-season__kicker {\n  color: #0369a1;\n}\n\nhtml[data-theme=\"dark\"] .pst-sq-board__title,\nbody.dark-mode .pst-sq-board__title {\n  color: #f8fafc;\n}\n\nhtml[data-theme=\"dark\"] .pst-sq-board__header .pst-season__kicker,\nbody.dark-mode .pst-sq-board__header .pst-season__kicker {\n  color: #7dd3fc;\n}\n\n.pst-sq-result-map {\n  background: color-mix(in srgb, #0877bc 6%, transparent);\n  border: 1px solid color-mix(in srgb, #0877bc 22%, var(--border-color));\n  border-radius: 14px;\n  padding: 12px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.pst-sq-result-map__result {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin: 0;\n  font-size: 0.95rem;\n  line-height: 1.4;\n}\n\n.pst-sq-result-map__result strong {\n  font-size: 0.68rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--text-secondary, #64748b);\n}\n\n.pst-sq-axes {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.pst-sq-axes li {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 0.9rem;\n  line-height: 1.35;\n}\n\n.pst-sq-axes--compact {\n  gap: 6px;\n}\n\n.pst-sq-dim__kicker {\n  margin: 0 0 6px;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--text-secondary, #64748b);\n}\n\n.pst-sq-phase {\n  background: color-mix(in srgb, #0877bc 6%, transparent);\n  border: 1px dashed color-mix(in srgb, #0877bc 28%, var(--border-color));\n  border-radius: 14px;\n  padding: 10px 12px;\n}\n\n.pst-sq-phase__lead {\n  margin: 6px 0 0;\n  font-size: 0.95rem;\n  line-height: 1.45;\n}\n\n.pst-sq-cta {\n  margin-top: 12px;\n  border: 0;\n  border-radius: 999px;\n  padding: 8px 12px;\n  font-weight: 700;\n  font-size: 12px;\n  background: #0877bc;\n  color: #fff;\n  cursor: pointer;\n}\n\n.pst-sq-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 10px;\n}\n\n.pst-sq-grid--smart {\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n}\n\n@media (max-width: 900px) {\n  .pst-sq-grid--smart {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 520px) {\n  .pst-sq-grid--smart {\n    grid-template-columns: 1fr;\n  }\n}\n\n.pst-collapse__head {\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n  font: inherit;\n}\n\n.pst-collapse__title {\n  display: block;\n  margin: 0;\n  font-size: 1rem;\n}\n\n.pst-collapse__hint {\n  display: block;\n  margin-top: 4px;\n  font-style: normal;\n  font-size: 0.78rem;\n  color: var(--text-secondary, #64748b);\n  line-height: 1.35;\n}\n\n.pst-collapse__chevron {\n  flex-shrink: 0;\n  font-size: 0.9rem;\n  color: var(--text-secondary, #64748b);\n  padding-top: 2px;\n}\n\n.pst-collapse__body {\n  margin-top: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.pst-sq-metrics {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n@media (max-width: 560px) {\n  .pst-sq-metrics {\n    grid-template-columns: 1fr;\n  }\n}\n\n.pst-sq-dim {\n  background: color-mix(in srgb, currentColor 4%, transparent);\n  border: 1px solid var(--profile-badge-border, rgba(128, 128, 128, 0.2));\n  border-radius: 14px;\n  padding: 10px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.pst-sq-dim__head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pst-sq-dim__letter {\n  width: 1.65rem;\n  height: 1.65rem;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 800;\n  font-size: 12px;\n  background: color-mix(in srgb, #0877bc 18%, transparent);\n  color: #0877bc;\n}\n\n.pst-sq-dim--a .pst-sq-dim__letter { background: color-mix(in srgb, #d97706 18%, transparent); color: #b45309; }\n.pst-sq-dim--r .pst-sq-dim__letter { background: color-mix(in srgb, #7c3aed 18%, transparent); color: #6d28d9; }\n.pst-sq-dim--m .pst-sq-dim__letter { background: color-mix(in srgb, #059669 18%, transparent); color: #047857; }\n.pst-sq-dim--t .pst-sq-dim__letter { background: color-mix(in srgb, #0891b2 18%, transparent); color: #0e7490; }\n\n.pst-sq-dim__title {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--text-secondary);\n  flex: 1;\n}\n\n.pst-sq-dim__lead {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 650;\n  line-height: 1.35;\n}\n\n.pst-sq-metric-line {\n  margin: 0;\n  font-size: 13px;\n}\n\n.pst-sq-time-bar {\n  margin-top: 6px;\n}\n\n.pst-traffic {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.pst-traffic--green { background: #22c55e; }\n.pst-traffic--yellow { background: #eab308; }\n.pst-traffic--red { background: #ef4444; }\n\n/* Coach SMART review grid */\n.dp-smart-grid {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.dp-smart-grid__cell {\n  border: 1px solid var(--border-color, rgba(128, 128, 128, 0.25));\n  border-radius: 12px;\n  padding: 10px 6px;\n  font-size: 12px;\n  background: var(--bg-card, rgba(128, 128, 128, 0.06));\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  min-height: 3.1rem;\n  cursor: pointer;\n  color: inherit;\n  font-family: inherit;\n}\n\n.dp-smart-grid__cell.is-active {\n  border-color: #0877bc;\n  box-shadow: 0 0 0 1px color-mix(in srgb, #0877bc 30%, transparent);\n}\n\n.dp-smart-grid__letter {\n  font-weight: 800;\n  font-size: 14px;\n}\n\n.dp-smart-grid__status {\n  display: block;\n  margin-top: 4px;\n  color: var(--text-secondary);\n  font-size: 11px;\n}\n\n/* Sprint exercise M table */\n.pst-sprint-table-wrap {\n  margin-top: 12px;\n}\n\n.pst-sprint-table__head {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.pst-sprint-table__badges {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  align-items: flex-start;\n}\n\n.pst-sprint-table-scroll {\n  overflow-x: auto;\n  border-radius: 12px;\n  border: 1px solid var(--profile-badge-border, rgba(128, 128, 128, 0.2));\n}\n\n.pst-sprint-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.pst-sprint-table th,\n.pst-sprint-table td {\n  padding: 10px 12px;\n  text-align: left;\n  border-bottom: 1px solid var(--profile-badge-border, rgba(128, 128, 128, 0.15));\n  vertical-align: top;\n}\n\n.pst-sprint-table th {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--text-secondary);\n  background: color-mix(in srgb, currentColor 4%, transparent);\n}\n\n.pst-sprint-row.is-ok {\n  background: color-mix(in srgb, #22c55e 6%, transparent);\n}\n\n.pst-sprint-row.is-warn {\n  background: color-mix(in srgb, #ef4444 5%, transparent);\n}\n\n.pst-sprint-row__goal {\n  min-width: 140px;\n}\n\n.pst-sprint-row__role {\n  margin-right: 6px;\n  opacity: 0.7;\n}\n\n.pst-sprint-row__sub {\n  display: block;\n  font-size: 12px;\n}\n\n.pst-sprint-metrics {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.pst-sprint-metrics__label {\n  display: block;\n  font-size: 11px;\n  color: var(--text-secondary);\n}\n\n.pst-sprint-ok {\n  color: #059669;\n  font-weight: 650;\n}\n\n.pst-sprint-warn {\n  color: #d97706;\n  font-weight: 650;\n}\n\n.pst-sprint-cb-groups {\n  margin-top: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.pst-sprint-cb-group summary {\n  cursor: pointer;\n  font-weight: 650;\n  font-size: 13px;\n}\n\n.pst-sprint-cb-list {\n  margin: 8px 0 0 18px;\n  padding: 0;\n  font-size: 13px;\n}\n\n.pst-sprint-card,\n.pst-measure-plan {\n  margin-bottom: 0;\n}\n\n.dp-people__sprint-review {\n  margin-bottom: 12px;\n}\n\n.pst-m,\n.pst-t {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.pst-meter-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 10px;\n}\n\n@media (min-width: 560px) {\n  .pst-meter-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n.pst-meter {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 14px 14px 12px;\n  border-radius: 16px;\n  background: var(--bg-card, #fff);\n  border: 1px solid var(--profile-badge-border, rgba(128, 128, 128, 0.16));\n}\n\n.pst-meter__kicker {\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: var(--text-secondary, #64748b);\n}\n\n.pst-meter__value {\n  font-size: 1.55rem;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  line-height: 1.1;\n  color: var(--text-color, #0f172a);\n}\n\n.pst-meter__unit {\n  font-size: 0.78rem;\n  color: var(--text-secondary, #64748b);\n  line-height: 1.3;\n}\n\n.pst-meter__pace {\n  font-size: 0.72rem;\n  font-weight: 650;\n  color: var(--brand-primary, #0877bc);\n  margin-top: 2px;\n}\n\n.pst-meter .pst-bar {\n  margin-top: 8px;\n}\n\n.pst-ae-card__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 4px;\n}\n\n.pst-ae-spark {\n  display: flex;\n  align-items: flex-end;\n  gap: 6px;\n  height: 56px;\n  margin: 10px 0 14px;\n  padding: 0 2px;\n}\n\n.pst-ae-spark__bar {\n  flex: 1;\n  min-width: 8px;\n  border-radius: 6px 6px 2px 2px;\n  background: linear-gradient(180deg, #34d399, #059669);\n  opacity: 0.9;\n}\n\n.pst-ae-last {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding-top: 10px;\n  border-top: 1px solid var(--profile-badge-border, rgba(128, 128, 128, 0.14));\n}\n\n.pst-ae-last__row {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.pst-ae-last__row strong {\n  font-size: 0.95rem;\n}\n\n.pst-ae-last__row span,\n.pst-ae-last__row em {\n  font-size: 0.8rem;\n  color: var(--text-secondary, #64748b);\n  font-style: normal;\n}\n\n.pst-miles__presence {\n  background: color-mix(in srgb, #fbbf24 10%, transparent);\n  border-radius: 12px;\n  padding: 10px 12px;\n  margin-bottom: 6px;\n}\n\n.pst-track {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.pst-track__head {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.pst-track__head .pst-h {\n  margin: 0;\n}\n\n.pst-track__goal {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 700;\n  line-height: 1.35;\n}\n\n.pst-track__stats {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.pst-track__stats > div {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 8px;\n  border-radius: 12px;\n  background: color-mix(in srgb, currentColor 5%, transparent);\n}\n\n.pst-track__stats strong {\n  font-size: 1.15rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n}\n\n.pst-track__stats span {\n  font-size: 0.68rem;\n  line-height: 1.25;\n  color: var(--text-secondary, #64748b);\n}\n\n.pst-track__bar {\n  position: relative;\n  height: 10px;\n  border-radius: 999px;\n  background: color-mix(in srgb, currentColor 10%, transparent);\n  overflow: visible;\n}\n\n.pst-track__fill {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: linear-gradient(90deg, #a78bfa, #7c3aed);\n}\n\n.pst-track__fill--cycle {\n  background: linear-gradient(90deg, #22d3ee, #0891b2);\n}\n\n.pst-track__now {\n  position: absolute;\n  top: 50%;\n  width: 14px;\n  height: 14px;\n  margin-left: -7px;\n  margin-top: -7px;\n  border-radius: 50%;\n  background: var(--brand-primary, #0877bc);\n  border: 2px solid #fff;\n  box-shadow: 0 0 0 2px color-mix(in srgb, var(--brand-primary, #0877bc) 35%, transparent);\n}\n\n.pst-track__ticks {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 6px;\n}\n\n.pst-track__ticks li {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 8px;\n  border-radius: 10px;\n  opacity: 0.65;\n}\n\n.pst-track__ticks li.is-current {\n  opacity: 1;\n  background: color-mix(in srgb, #22d3ee 12%, transparent);\n}\n\n.pst-track__ticks strong {\n  font-size: 0.78rem;\n}\n\n.pst-track__ticks span {\n  font-size: 0.7rem;\n  color: var(--text-secondary, #64748b);\n}\n\n.pst-track--season {\n  border-color: color-mix(in srgb, #a78bfa 28%, var(--profile-badge-border, transparent));\n}\n\n.pst-track--cycle {\n  border-color: color-mix(in srgb, #22d3ee 28%, var(--profile-badge-border, transparent));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
